module.exports = __webpack_public_path__ + "034875746f635d011e77e6adc81e174c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/cell-phone.png
// module id = 2992
// module chunks = 0